module.exports = __webpack_public_path__ + "df4d5c4f5397f6a193bdc7b680fa9564.svg";